import { localize } from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru.json';

localize('ru', ru);
localize({
  ru: {
    messages: {
      confirmed: "Поле не совпадает",
    },
  },
});
